import { api } from '../../../../../lib';
import { SetupBasicConfigResponseSchema, SetupBasicConfigSchema } from './schema';

export const getSetupIpaBasicConfig = async (): Promise<SetupBasicConfigResponseSchema> => {
  const response = await api.get<SetupBasicConfigResponseSchema>('/setup/basic-config', {
    expectToken: true,
  });

  return response.data;
};

export const postSetupIpaBasicConfig = async (data: Omit<SetupBasicConfigSchema, 'id'>): Promise<Required<SetupBasicConfigSchema>> => {
  const response = await api.post<Required<SetupBasicConfigSchema>>('/setup/basic-config', data, {
    expectToken: true,
  });
  return response.data;
};

export const putSetupIpaBasicConfig = async (data: Required<SetupBasicConfigSchema>): Promise<Required<SetupBasicConfigSchema>> => {
  const response = await api.put<Required<SetupBasicConfigSchema>>('/setup/basic-config', data, {
    expectToken: true,
  });
  return response.data;
};
